import { render, staticRenderFns } from "./HelloMartin.vue?vue&type=template&id=63d0f0cd&"
import script from "./HelloMartin.vue?vue&type=script&lang=js&"
export * from "./HelloMartin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports